export const getSelectRecipientModalInitialState = () => ({
	contacts: [],
	error: false,
	filterChangeConfirmation: false,
	isLoading: false,
	leadIds: [],
	noResultsFound: false,
	pageNumber: 1,
	pageSize: 20,
	searchTerm: '',
	selectedBrokers: [],
	selectedFilters: [],
	sendAllConfirmation: false,
	totalCount: null,
});
